import React from 'react';
import PropTypes from 'prop-types';

import ScrollToTop from 'components/consumer/blog/components/ScrollToTop/ScrollToTop';
import CustomerDashboardPageTemplate from 'components/consumer/CustomerDashboardPageTemplate';

const UpChargeSuccess = ({ planName, upholsteryName, productName }) => (
  <div data-xc={planName ? 'protection-plans-page' : 'orders-page'}>
    <CustomerDashboardPageTemplate
      title={planName ? 'Protection Plans' : 'Orders'}
    >
      <ScrollToTop delay={500} />
      <div className="p-8 text-brand bg-brand-lighter">
        <div className="text-xl font-bold mb-[.325rem] text-brand-dark">
          Congrats!{' '}
          {planName
            ? 'Your Protection plan has been confirmed.'
            : 'Your order has been confirmed.'}
        </div>
        <div className="text-base">
          {planName ? (
            <>
              {planName} has been applied to your {productName}
            </>
          ) : upholsteryName && productName ? (
            <>
              {upholsteryName} has been applied to your {productName}. Our team
              can start the process of building your furniture. We&apos;ll
              provide you with live build updates as we move through the
              production process so you&apos;re in the know every step of the
              way.
            </>
          ) : (
            <>
              Upholstery has been successfully applied. We&apos;ll start the
              process of building your furniture, and we&apos;ll provide you
              with live build updates as we move through the production process.
            </>
          )}
        </div>
      </div>
    </CustomerDashboardPageTemplate>
  </div>
);

UpChargeSuccess.propTypes = {
  planName: PropTypes.string,
  productName: PropTypes.string,
  upholsteryName: PropTypes.string,
};

export default UpChargeSuccess;
